'use strict';

import Ping from "@/helpers/ping";

(function () {
   const ping = new Ping();

   const locationOptions = document.querySelectorAll('option[data-role="location-ping"]');
   const pingUrlMap = new Map(); // Map of pingUrl -> array of optionElements

   // Step 1: Group option elements by their pingUrl
   locationOptions.forEach(option => {
      const pingUrl = option.getAttribute("data-url");
      if (!pingUrl) return;

      if (!pingUrlMap.has(pingUrl)) {
         pingUrlMap.set(pingUrl, []);
      }
      pingUrlMap.get(pingUrl).push(option);
   });

   let lowestPing = -1;
   let bestOption = null;

   // Step 2: Ping each unique URL once
   pingUrlMap.forEach((optionElements, pingUrl) => {
      ping.PingWebSocket(pingUrl, 3, 100).then(e => {
         const latency = e.latency;
         const hasLocationParam = new URLSearchParams(window.location.search).has("location");

         // Update all optionElements with same pingUrl
         optionElements.forEach(option => {
            if (latency > 0) {
               option.innerHTML = `${option.textContent} - ${latency}ms`;
               console.log(`${pingUrl} ${latency}`);
            }

            if (!hasLocationParam && latency > 0 && (lowestPing === -1 || latency < lowestPing)) {
               lowestPing = latency;
               bestOption = option;
            }
         });

         // If this option is the current best, select it and trigger change
         if (bestOption) {
            bestOption.selected = true;
            const select = bestOption.parentElement;
            const event = new Event('change', { bubbles: true });
            select.dispatchEvent(event);
         }

      }).catch(err => {
         console.error(`Ping failed for ${pingUrl}:`, err);
      });
   });
})();
